var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDoc = function SvgDoc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 34
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3D5AFE",
    d: "M17.06 0l.077.08 9.617 9.617c.137.137.287.253.446.347v21.69A2.267 2.267 0 0124.933 34H2.267A2.267 2.267 0 010 31.733V2.267A2.267 2.267 0 012.267 0H17.06z"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFF",
    fontFamily: "Rubik-Medium, Rubik",
    fontSize: 9.067,
    fontWeight: 400
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 4.157,
    y: 21.6
  }, "DOC")), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M17 2.267l7.933 7.933H17z"
  }))));
};
export default SvgDoc;